export default __webpack_public_path__ + "static/story_travel-f8fa9a7f3510ec29a6d817732e7437d5.mp4";